<template>
  <div>
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col
              cols="12"
              sm="9"
              class="hidden-xs-only"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon>
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Fases: {{ competenciaWorldskillsNacional.competencia }}
            </v-col>

            <template v-if="competenciasWorldSkills.length > 0">
              <v-col 
                cols="12" 
                sm="3"
              >
                <v-text-field 
                  outlined 
                  dense 
                  append-icon="mdi-magnify" 
                  label="Buscar Competencia" 
                  hide-details
                  v-model="searchTable"
                >
                </v-text-field>
              </v-col>
            </template>
          </v-row>
        </v-card-title>
        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="competenciasWorldSkills"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="detalle(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <template v-if="perfilAdminNacional || perfilLiderNacional">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="actualizar(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Actualizar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="registrarDocumento(item.id)"
                  >
                    mdi-file-document
                  </v-icon>
                </template>
                <span>Gestionar Documentos</span>
              </v-tooltip>
            </template>

            <template v-if="!perfilExpertoRegional">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="asociarHabilidad(item.id)"
                  >
                    mdi-playlist-plus
                  </v-icon>
                </template>
                <template v-if="perfilAdminNacional || perfilLiderNacional">
                  <span>Asociar Habilidades</span>
                </template>
                <template v-else>
                  <span>Gestionar Habilidades</span>
                </template>
              </v-tooltip>
            </template>

            <template v-if="!perfilExpertoRegional">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="registrarAcompanante(item.id)"
                  >
                    mdi-account-plus
                  </v-icon>
                </template>
                <span>Gestionar Acompañantes</span>
              </v-tooltip>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    headersTable: [
      {
        text: "Competencia",
        value: "competencia",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Fecha de Inicio",
        value: "fecha_inicio",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Fecha de Finalización",
        value: "fecha_fin",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"]
      }
    ]
  }),
  
  mounted() {
    this.$store.dispatch("gestionarCompetenciasWorldSkills")
    this.$store.dispatch("detalleCompetenciaWorldSkills", this.$route.params.id_competencia)
    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    usuario() {
      return this.$store.getters.usuario
    },

    perfilAdminNacional() {
      return this.$store.getters.perfilAdminNacional
    },

    perfilLiderNacional() {
      return this.$store.getters.perfilLiderNacional
    },

    perfilExpertoNacional() {
      return this.$store.getters.perfilExpertoNacional
    },
    
    perfilEnlaceRegional() {
      return this.$store.getters.perfilEnlaceRegional
    },

    perfilExpertoRegional() {
      return this.$store.getters.perfilExpertoRegional
    },

    competenciaWorldskillsNacional() {
      return this.$store.getters.obtenerCompetenciaWorldSkills
    },

    competenciasWorldSkills() {
      const competencias = this.$store.getters.obtenerCompetenciasWorldSkills
      
      if (this.perfilEnlaceRegional) {
        return competencias.filter(competencia => competencia.competencia_id == this.$route.params.id_competencia 
          && competencia.tipo_competencia_id == 3)
      }

      else if (this.perfilExpertoNacional) {
        return competencias.filter(competencia => competencia.competencia_id == this.$route.params.id_competencia 
          && competencia.tipo_competencia_id == 4)
      }

      else {
        return competencias.filter(competencia => competencia.competencia_id == this.$route.params.id_competencia)
      }
    },
  },

  methods: {
    detalle(competencia) {
      this.$router.push({
        name: "competenciaws-detalles",
        params: { id_competencia: competencia }
      });
    },

    actualizar(competencia) {
      this.$router.push({
        name: "competenciaws-actualizar",
        params: { id_competencia: competencia }
      });
    },

    registrarDocumento(competencia) {
      this.$router.push({
        name: "competenciaws-documentos",
        params: { id_competencia: competencia }
      })
    },

    asociarHabilidad(competencia) {
      this.$router.push({
        name: "asignar-habilidad",
        params: { id_competencia: competencia }
      });
    },

    registrarAcompanante(competencia) {
      this.$router.push({
        name: "gestionar-acompanante",
        params: { id_competencia: competencia }
      })
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>
